import React from 'react';
import { trackExternalLink, trackButtonClick } from '../utils/analytics';
import { CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_TEL } from '../utils/emailConfig';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/logo192.png" alt="" className="logo-icon" width="56" height="56" />
              <div className="logo-text">
                <span className="logo-main">Devil's Highway</span>
                <span className="logo-sub">Motorcycle Tours</span>
              </div>
            </div>
            <p className="footer-description">
              Experience America's most twisted road with professional guidance. 
              650 turns, 120 miles, 3 unforgettable days through the rugged Southwest.
            </p>
            <div className="social-links">
              <a 
                href="https://facebook.com/devilshighwaytours" 
                className="social-link" 
                aria-label="Facebook"
                onClick={() => trackExternalLink('https://facebook.com/devilshighwaytours', 'Facebook')}
              >
                <span>📘</span>
              </a>
              <a 
                href="https://instagram.com/devilshighwaytours" 
                className="social-link" 
                aria-label="Instagram"
                onClick={() => trackExternalLink('https://instagram.com/devilshighwaytours', 'Instagram')}
              >
                <span>📷</span>
              </a>
              <a 
                href="https://youtube.com/devilshighwaytours" 
                className="social-link" 
                aria-label="YouTube"
                onClick={() => trackExternalLink('https://youtube.com/devilshighwaytours', 'YouTube')}
              >
                <span>📺</span>
              </a>
              <a 
                href="https://twitter.com/devilshighwaytours" 
                className="social-link" 
                aria-label="Twitter"
                onClick={() => trackExternalLink('https://twitter.com/devilshighwaytours', 'Twitter')}
              >
                <span>🐦</span>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#hero" className="footer-link" onClick={() => trackButtonClick('footer_nav_hero', 'footer')}>Home</a></li>
              <li><a href="#tour-details" className="footer-link" onClick={() => trackButtonClick('footer_nav_tour-details', 'footer')}>Tour Details</a></li>
              <li><a href="#itinerary" className="footer-link" onClick={() => trackButtonClick('footer_nav_itinerary', 'footer')}>Itinerary</a></li>
              <li><a href="#pricing" className="footer-link" onClick={() => trackButtonClick('footer_nav_pricing', 'footer')}>Pricing</a></li>
              <li><a href="#booking" className="footer-link" onClick={() => trackButtonClick('footer_nav_booking', 'footer')}>Book Now</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Tour Information</h4>
            <ul className="footer-links">
              <li><a href="/Accident_Waiver_and_Release.pdf" className="footer-link" target="_blank" rel="noopener noreferrer">Waiver</a></li>
              <li><a href="#pricing" className="footer-link" onClick={() => trackButtonClick('footer_nav_pricing', 'footer')}>Pricing</a></li>
              <li><a href="#booking" className="footer-link" onClick={() => trackButtonClick('footer_nav_booking', 'footer')}>Book Now</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">📧</span>
                <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <a href={`tel:${CONTACT_PHONE_TEL}`}>{CONTACT_PHONE}</a>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span>Phoenix, Arizona</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">🕒</span>
                <span>Mon-Fri: 9AM-6PM MST</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-legal">
              <p>&copy; 2026 Devil's Highway Motorcycle Tours. All rights reserved.</p>
              <div className="legal-links">
                <a href="/Accident_Waiver_and_Release.pdf" className="legal-link" target="_blank" rel="noopener noreferrer">Waiver</a>
              </div>
            </div>
            <a
              href="#hero"
              onClick={() => trackButtonClick('back_to_top', 'footer')}
              className="back-to-top"
            >
              <span className="back-to-top-icon">↑</span>
              <span>Back to Top</span>
            </a>
          </div>
        </div>

        <div className="footer-disclaimer">
          <div className="disclaimer-content">
            <span className="disclaimer-icon">⚠️</span>
            <div>
              <h5>Important Disclaimer</h5>
              <p>
                The Devil's Highway is an advanced riding experience requiring significant motorcycle skills. 
                All participants must have proper riding experience, full protective gear, and a well-maintained motorcycle. 
                Weather conditions and road hazards may affect the tour. Please review all safety requirements before booking.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
